export default __webpack_public_path__ + "static/Group 1963-5b44eb5cfd573e4c92c5aa3718f6ddde.png";